import React from "react";

function Success({ confirmationCode, onClose, setConfirmationCode, theme, refreshInventory }) {
  const styles = {
    container: {
      backgroundColor: "transparent",
      color: theme.primaryFontColor,
      borderRadius: "10px",
      width: "100%",
    },
    title: {
      color: theme.primaryFontColor,
      fontSize: "20px",
      marginBottom: "20px",
    },
    message: {
      textAlign: "center",
      fontSize: "18px",
      marginBottom: "55px",
      padding: 50,
    },
    button: {
      backgroundColor: theme.accentColor,
      color: "white",
      border: "none",
      padding: "10px 15px",
      borderRadius: "5px",
      cursor: "pointer",
      width: 150,
    },
    footer: {
      position: "absolute",
      bottom: "0",
      left: "0",
      right: "0",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "transparent",
      borderTop: "1px solid #ccc",
    },
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>Completed</h3>
      <div
        name="divider"
        style={{
          backgroundColor: theme.primaryFontColor,
          height: 1,
        }}
      />
      <div style={styles.message}>
        <strong>Great!</strong> <br />
        <br />
        Your order has been processed and a receipt has been sent to your email.
        {/* <br /> <br />
        You will also receive a text message that will connect you to our reps. */}
        <br />
        <br />
        Your order confirmation code is <strong>#{confirmationCode}</strong>.
        <br />
        <br />
        Save this for any customer support questions.
      </div>

      <div style={styles.footer}>
        <div style={{ flex: 2, textAlign: "right" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <div></div>

            <button
              style={styles.button}
              onClick={() => {
                onClose(); // Call the onClose function
                setConfirmationCode(""); // Reset the confirmation code
                refreshInventory();
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Success;
